import { BaseDto } from '@/shared/dtos/base-dto';

export class ambito extends BaseDto {
    public nombre !: string;
    public nomenclatura !: string;
    public id_ambito !: number;
 } 
